module.exports = __webpack_public_path__ + "img/d900ff0.jpg";